<template>
  <div>
    <PageTitle
      title="Customers"
      :btnCreate="true"
      :createRoute="'customer/add'"
      :permission="'Customer Create'"
    />

    <v-container
      fluid
      class="lighten-12 content"
      style="background-color: white"
    >
      <!-- Page Title -->
      <v-btn :ripple="false" class="min-button" icon @click="show = !show">
        <v-icon color="blue" class="ml-10">
          {{ show ? 'mdi-filter' : 'mdi-filter-outline' }}
        </v-icon>
        <span class="subheading filterclor">Filter</span>
      </v-btn>
      <v-expand-transition>
        <v-card class="lighten-12 card-content" v-show="show">
          <TableFilters
            :filters="['status', 'search', 'customerType']"
            v-model="filter"
            :columns="columns"
            :msgs="'Name/Ref No'"
          >
          </TableFilters>
        </v-card>
      </v-expand-transition>
      <v-card class="mt-2">
        <v-container fluid class="light gray lighten-12">
          <!-- Data Table -->
          <v-row>
            <v-card-text class="pa-0 caption">
              <v-data-table
                :items-per-page="paginationOptions.perPage"
                :fixed-header="true"
                :headers="headers"
                :items="customer"
                :single-expand="singleExpand"
                :expanded.sync="expanded"
                item-key="id"
                show-expand
                hide-default-footer
                class="row-pointer dtc"
                @click:row="$router.push(`customer/${$event.id}`)"
                style="
                  font-weight: normal;
                  font-family: 'Source Sans Pro', sans-serif;
                "
              >
                <template v-slot:item.name="{ item }">
                  <v-list-item class="px-0">
                    <v-list-item-avatar size="24px" color="primary">
                      <img
                        v-if="item.image"
                        :src="item.image"
                        height="16"
                        width="16"
                        class="image"
                      />
                      <v-avatar v-else size="16px" item color="primary">
                        <span class="white--text subtitle-2 text-uppercase">
                          {{ item.name.charAt(0) }}</span
                        >
                      </v-avatar>
                    </v-list-item-avatar>

                    <v-list-item-content>
                      <v-list-item-title>
                        {{ item.name
                        }}<v-tooltip top color="primary">
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon
                              class="ma-2"
                              color="grey lighten-1"
                              small
                              dark
                              v-bind="attrs"
                              v-on="on"
                              >mdi-information</v-icon
                            >
                          </template>
                          <span>No Of Sales - {{ salescount(item) }}</span>
                        </v-tooltip></v-list-item-title
                      >
                    </v-list-item-content>
                  </v-list-item>
                </template>
                <template v-slot:no-data>
                  <noData
                    class="mt-16 container justify-center item-center"
                    name="customers"
                  />
                </template>
                <template v-slot:item.due_amount="{ item }">
                  <v-chip
                    v-if="item.due_amount > 0"
                    :x-small="true"
                    class="ma-2"
                    label
                    style="font-weight: bold; font-size: revert"
                    text-color="white"
                    color="red"
                    dark
                    >{{
                      item.due_amount
                        ? item.due_amount
                        : '---------' | formatCurrency
                    }}</v-chip
                  >
                  <v-chip
                    v-else
                    :x-small="true"
                    style="font-weight: bold; font-size: revert"
                    class="ma-2"
                    label
                    text-color="white"
                    color="green"
                    dark
                    >{{
                      item.due_amount
                        ? item.due_amount
                        : '---------' | formatCurrency
                    }}</v-chip
                  >
                </template>
                <template v-slot:item.reference_number="{ item }">
                  <CopyTableCell :text="item.reference_number"></CopyTableCell>
                </template>
                <template v-slot:item.customerType.name="{ item }">
                  <v-chip
                    :x-small="true"
                    class="ma-2 f-100"
                    label
                    text-color="white"
                    :color="getSaleTypeColor(item.customerType.name)"
                    dark
                    style="
                      color: white;
                      font-variant-caps: all-small-caps;
                      font-weight: bold;
                    "
                    >{{
                      item.customerType.name
                        ? item.customerType.name
                        : '---------'
                    }}</v-chip
                  >
                </template>
                <template v-slot:item.contact[0].phone="{ item }">
                  <a
                    href=""
                    :style="
                      item.contact[0] && item.contact[0].phone
                        ? { color: 'black' }
                        : { 'text-decoration': 'none' }
                    "
                  >
                    {{ item.contact[0] ? item.contact[0].phone : '---------' }}
                  </a>
                </template>
                <template v-slot:expanded-item="{ headers, item }">
                  <td :colspan="headers.length" class="px-5">
                    <v-row>
                      <v-col
                        cols="12"
                        sm="12"
                        md="12"
                        lg="6"
                        v-if="item.contact.length"
                      >
                        <v-card class="lighten-12">
                          <v-card-title class="v-card__title saletiltle"
                            ><v-icon small color="blue">mdi-contacts</v-icon
                            ><span class="pl-3"> Contact</span>
                          </v-card-title>
                          <v-container fluid class="container saledetailscard">
                            <v-row>
                              <v-col
                                cols="12"
                                sm="12"
                                md="12"
                                lg="12"
                                class="pt-0 sub-section"
                                v-for="item in item.contact"
                                :key="item"
                              >
                                <v-row class="pt-0">
                                  <v-col
                                    cols="5"
                                    sm="12"
                                    md="5"
                                    lg="5"
                                    class="paymenttext"
                                  >
                                    Full Name
                                  </v-col>
                                  <v-col
                                    cols="7"
                                    sm="12"
                                    md="7"
                                    lg="7"
                                    class="saletiltle"
                                    style="text-align: right"
                                  >
                                    {{
                                      item.full_name ? item.full_name : '---'
                                    }}
                                  </v-col>
                                </v-row>
                                <v-divider></v-divider>
                                <v-row class="pt-0">
                                  <v-col
                                    cols="5"
                                    sm="12"
                                    md="5"
                                    lg="5"
                                    class="paymenttext"
                                  >
                                    Telephone
                                  </v-col>
                                  <v-col
                                    cols="7"
                                    sm="12"
                                    md="7"
                                    lg="7"
                                    class="saletiltle"
                                    style="text-align: right"
                                  >
                                    <a
                                      href=""
                                      :style="
                                        item.telephone && item.telephone
                                          ? { color: 'light-blue' }
                                          : { 'text-decoration': 'none' }
                                      "
                                    >
                                      {{
                                        item.telephone ? item.telephone : '---'
                                      }}</a
                                    >
                                  </v-col>
                                </v-row>
                                <v-divider></v-divider>
                                <v-row class="pt-0">
                                  <v-col
                                    cols="5"
                                    sm="12"
                                    md="5"
                                    lg="5"
                                    class="paymenttext"
                                  >
                                    Phone
                                  </v-col>
                                  <v-col
                                    cols="7"
                                    sm="12"
                                    md="7"
                                    lg="7"
                                    class="saletiltle"
                                    style="text-align: right"
                                  >
                                    <a href="">
                                      {{ item.phone ? item.phone : '---' }}</a
                                    >
                                  </v-col>
                                </v-row>
                                <v-divider></v-divider>
                                <v-row class="pt-0">
                                  <v-col
                                    cols="5"
                                    sm="12"
                                    md="5"
                                    lg="5"
                                    class="paymenttext"
                                  >
                                    Email
                                  </v-col>
                                  <v-col
                                    cols="7"
                                    sm="12"
                                    md="7"
                                    lg="7"
                                    class="saletiltle"
                                    style="text-align: right"
                                  >
                                    {{ item.email ? item.email : '---' }}
                                  </v-col>
                                </v-row>
                                <v-divider></v-divider>
                                <v-row class="pt-0">
                                  <v-col
                                    cols="5"
                                    sm="12"
                                    md="5"
                                    lg="5"
                                    class="paymenttext"
                                  >
                                    Contactable Type
                                  </v-col>
                                  <v-col
                                    cols="7"
                                    sm="12"
                                    md="7"
                                    lg="7"
                                    class="saletiltle"
                                    style="text-align: right"
                                  >
                                    {{
                                      item.contactable_type
                                        ? item.contactable_type
                                        : '---'
                                    }}
                                  </v-col>
                                </v-row>
                                <v-divider></v-divider>
                              </v-col>
                            </v-row>
                          </v-container>
                        </v-card>
                      </v-col>
                      <v-col
                        cols="12"
                        sm="12"
                        md="12"
                        lg="6"
                        v-if="item.address.length"
                      >
                        <v-card class="lighten-12">
                          <v-card-title class="v-card__title saletiltle"
                            ><v-icon color="blue" small>mdi-city</v-icon
                            ><span class="pl-3"> Address</span>
                          </v-card-title>
                          <v-container fluid class="container saledetailscard">
                            <v-row>
                              <v-col
                                cols="12"
                                sm="12"
                                md="12"
                                lg="12"
                                class="pt-0 sub-section"
                                v-for="item in item.address"
                                :key="item"
                              >
                                <v-row class="pt-0">
                                  <v-col
                                    cols="5"
                                    sm="12"
                                    md="5"
                                    lg="5"
                                    class="paymenttext"
                                  >
                                    Address Line 1
                                  </v-col>
                                  <v-col
                                    cols="7"
                                    sm="12"
                                    md="7"
                                    lg="7"
                                    class="saletiltle"
                                    style="text-align: right"
                                  >
                                    {{
                                      item.address_line1
                                        ? item.address_line1
                                        : '---'
                                    }}
                                  </v-col>
                                </v-row>
                                <v-divider></v-divider>
                                <v-row class="pt-0">
                                  <v-col
                                    cols="5"
                                    sm="12"
                                    md="5"
                                    lg="5"
                                    class="paymenttext"
                                  >
                                    Address Line 2
                                  </v-col>
                                  <v-col
                                    cols="7"
                                    sm="12"
                                    md="7"
                                    lg="7"
                                    class="saletiltle"
                                    style="text-align: right"
                                  >
                                    {{
                                      item.address_line2
                                        ? item.address_line2
                                        : '---'
                                    }}
                                  </v-col>
                                </v-row>
                                <v-divider></v-divider>
                                <v-row class="pt-0">
                                  <v-col
                                    cols="5"
                                    sm="12"
                                    md="5"
                                    lg="5"
                                    class="paymenttext"
                                  >
                                    City
                                  </v-col>
                                  <v-col
                                    cols="7"
                                    sm="12"
                                    md="7"
                                    lg="7"
                                    class="saletiltle"
                                    style="text-align: right"
                                  >
                                    {{ item.city ? item.city : '---' }}
                                  </v-col>
                                </v-row>
                                <v-divider></v-divider>
                                <v-row class="pt-0">
                                  <v-col
                                    cols="5"
                                    sm="12"
                                    md="5"
                                    lg="5"
                                    class="paymenttext"
                                  >
                                    Postal Code
                                  </v-col>
                                  <v-col
                                    cols="7"
                                    sm="12"
                                    md="7"
                                    lg="7"
                                    class="saletiltle"
                                    style="text-align: right"
                                  >
                                    {{
                                      item.postal_code
                                        ? item.postal_code
                                        : '---'
                                    }}
                                  </v-col>
                                </v-row>
                                <v-divider></v-divider>
                                <v-row class="pt-0">
                                  <v-col
                                    cols="5"
                                    sm="12"
                                    md="5"
                                    lg="5"
                                    class="paymenttext"
                                  >
                                    Country
                                  </v-col>
                                  <v-col
                                    cols="7"
                                    sm="12"
                                    md="7"
                                    lg="7"
                                    class="saletiltle"
                                    style="text-align: right"
                                  >
                                    {{
                                      item.country ? item.country.name : '---'
                                    }}
                                  </v-col>
                                </v-row>
                                <v-divider></v-divider>
                              </v-col>
                            </v-row>
                          </v-container>
                        </v-card>
                      </v-col>
                    </v-row>
                    <template
                      v-if="
                        item.contact.length == 0 && item.address.length == 0
                      "
                    >
                      <v-card>
                        <v-container fluid> No Contacts & Address</v-container>
                      </v-card></template
                    >
                  </td>
                </template>

                <template v-slot:footer>
                  <pagination
                    @paginationOptions="setPaginationOptions"
                    @response="setResponseData"
                    url="customers"
                    :filterAction="true"
                    @getPageNumber="setPagenumber"
                    :filter="filter"
                    ref="pagination"
                  />
                </template>

                <template v-slot:item.is_active="{ item }">
                  <v-chip
                    :x-small="true"
                    class="ma-2"
                    label
                    style="font-weight: 800; font-variant-caps: all-small-caps"
                    text-color="white"
                    :color="getStatusColor(item.is_active)"
                    dark
                    >{{ item.is_active ? 'Active' : 'Archived' }}</v-chip
                  >
                </template>
                <template v-slot:item.created_at="{ item }">
                  {{ item.created_at | formatDate }}
                </template>

                <template v-slot:item.action="{ item }">
                  <list-menu
                    feature="customer"
                    :item="item"
                    viewPermission="Customer Show"
                    editPermission="Customer Edit"
                    softDeletePermission="Customer Soft Delete"
                    @refreshList="refreshData"
                  ></list-menu>
                </template>
              </v-data-table>
            </v-card-text>
          </v-row>
        </v-container>
      </v-card>
      <!-- </v-card> -->
      <div class="d-flex justify-center align-center"></div>
    </v-container>
  </div>
</template>

<script>
import { required, email, max } from 'vee-validate/dist/rules';
import pagination from '../../shared/components/pagination';
import { CustomerViewModel } from '../../../models/View Models/CustomerViewModel';
import noData from '../../../components/shared/noItem';

import _ from 'lodash';
import { extend, ValidationObserver, ValidationProvider } from 'vee-validate';
import TableFilters from '@/components/base/TableFilters';
extend('required', {
  ...required,
  message: '{_field_} is required',
});

extend('max', {
  ...max,
  message: '{_field_} may not be greater than {length} characters',
});

extend('email', {
  ...email,
  message: 'Email must be valid',
});

export default {
  data: () => ({
    show: false,
    paginationOptions: {},
    expanded: [],
    singleExpand: false,
    pagination1: {
      descending: true,
      page: 1,
      rowsPerPage: 2,

      sortBy: 'fat',
      totalItems: 0,
      rowsPerPageItems: [1, 2, 4, 8, 16],
    },

    pagination: {
      page: 1,
      itemsPerPage: 2,
    },
    page: 1,
    status: [
      { text: 'Active', value: 'active' },
      { text: 'Archived', value: 'archived' },
    ],
    columns: [
      {
        text: 'Name',
        value: 'name',
        show: true,
        disabled: false,
        align: 'left',
      },
      {
        text: 'Ref No',
        value: 'reference_number',
        show: true,
        disabled: false,
        align: 'left',
      },
      {
        text: 'Type',
        value: 'customerType.name',
        show: true,
        align: 'center',
        disabled: false,
      },
      {
        text: 'Contact',
        value: 'contact[0].phone',
        show: true,
        disabled: true,
        align: 'left',
      },
      {
        text: 'Due Amount',
        value: 'due_amount',
        show: true,
        align: 'center',
        disabled: false,
      },
      {
        text: 'Status',
        value: 'is_active',
        show: true,
        disabled: false,
        align: 'center',
      },
      {
        text: 'Actions',
        value: 'action',
        show: true,
        disabled: true,
        align: 'center',
      },
    ],
    customer: [],
    filter: {
      name: '',
      search: '',
      status: '',
      customerType: '',
    },
  }),
  components: {
    TableFilters,
    ValidationProvider,
    ValidationObserver,
    pagination,
    noData,
  },

  methods: {
    salescount(count) {
      let countsale = count.sales.length;
      return countsale;
    },
    getSaleTypeColor(saletype) {
      switch (saletype) {
        case 'cash':
          return 'green';
          break;
        case 'Credit':
          return 'red';
          break;
        default:
          break;
      }
    },
    setPaginationOptions(data) {
      this.paginationOptions = data;
    },
    setPagenumber(event) {
      this.$router.push('?page=' + event);
      this.$store.dispatch('SetProductSize', event);
    },
    refreshData() {
      this.$refs.pagination.refreshData();
    },

    setResponseData(customer) {
      this.customer = customer.map((u, i, arr) => {
        u.index = i + 1;

        if (u.contact?.length && !u.contact[0].full_name && u.displayName) {
          u.contact[0].full_name = u.displayName;
        }

        return new CustomerViewModel(u);
      });
    },

    getStatusColor(status) {
      return status ? 'green' : 'gray';
    },

    clearFilter() {
      this.filter = {};
    },
  },
  computed: {
    // Filter - return selected table fields
    headers: function () {
      return this.columns.filter((item) => item.show == true);
    },
  },
};
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Source+Sans+Pro&display=swap');

.dtc {
  font-weight: bold;
}
.saletiltle {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 2px;
}
.saledetailscard {
  background: #fffefe;
  box-sizing: border-box;
  border: 1px solid #afa9a9;
  box-shadow: inset 0px 4px 4px rgba(0, 0, 0, 0.25);
}
.paymenttext {
  font-family: 'Source Sans Pro', sans-serif;
  font-style: normal;
  font-weight: bold;
  font-size: 12px;
  line-height: 12px;
  /* identical to box height */

  text-align: left;

  color: #928686;
}

.styleB {
  text-decoration: none;
}
.filterclor {
  color: cornflowerblue;
  font-size: larger;
  font-weight: bold;
}
.min-button::before {
  display: none;
}
</style>
